<template>
    <div>
        <fluke-card>
            <v-form v-model="valid" @submit.prevent="submit" ref="form">
                <header>
                    <div class="title">Adicionar Curso</div>
                    <div class="description">Adcione as informações do curso</div>
                </header>
                <main>
                    <v-text-field label="Nome" v-model="title" required :rules="requiredRules"></v-text-field>
                </main>
                <footer>
                    <fluke-button type="submit">Adicionar</fluke-button>
                </footer>
            </v-form>
        </fluke-card>
    </div>
</template>

<script>
import axios from 'axios';

import Card from '../../components/Main/Content/Card/Card.vue';
import Button from '../../components/Main/Content/Button/Button.vue';

import permission from '../../mixins/permissions';

export default {
    mixins: [ permission ],
    components: {
        'fluke-card': Card,
        'fluke-button': Button
    },
    data: function() {
        return {
            title: '',
            permission: {
                read: false,
                write: false
            },
            valid: false,
            requiredRules: [
                v => !!v || 'Digite o título do curso',
            ],
        }
    },
    created: function() {
        this.permission = this.getUserPagePermission('courses');
		if( this.permission.read == false || this.permission.write == false ) {
			this.$router.push('/');
		}
    },
    methods: {
        validate () {
            return this.$refs.form.validate()
        },
        submit: async function() {
            if (!this.validate()) return false

            const result = await axios.post(
				this.$myServerAddresses.courses + 'courses',
				{
                    title: this.title
				},
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );

            var courseId = result.data[0];
            this.$router.push({ name: 'courses-edit', params: { id: courseId } });
        }
    }
}
</script>
